import { defineStore } from 'pinia';

const defaultDateTimeConfig = {
  full: 'DD/MM/YYYY HH:mm:ss',
  date: 'DD/MM/YYYY',
  time: 'HH:mm:ss',
  dayMonthNumeric: 'DD/MM',
  dayMonthShort: 'DD MMM',
  dayMonthLong: 'DD MMMM',
  monthYearNumeric: 'MM/YYYY',
  monthYearShort: 'MMM YYYY',
  monthYearLong: 'MMMM YYYY',
  hourMinute: 'HH:mm',
  year: 'YYYY',
  month: 'MM',
  day: 'DD',
  hour: 'HH',
  minute: 'mm',
  second: 'ss',
  ampm: '',
  monthShort: 'MMM',
  monthLong: 'MMMM',
  dateSeparator: '/',
  timeSeparator: ':',
  is12h: false,
  timezone: 'Asia/Singapore',
  primeVueDateConfig: {
    date: 'dd/mm/yy'
  }
};

export const useAppStore = defineStore('appStore', {
  state: () => ({
    loadingCount: 0,
    leftDrawerOpen: false,
    topbarNavigationTitle: '',
    topbarProcessTitle: '',
    topbarNavigationTimeLabel: '',
    topbarShowCloseButton: false, // New field to control close button display
    topbarHideLeft: false, // Hide entire left area (Back/Close/Avatar)
    overlayTopbar: false,
    dateTimeConfig: { ...defaultDateTimeConfig },
  }),
  getters: {
    isLoading: (state) => state.loadingCount > 0,
    isLeftDrawerOpen: (state) => state.leftDrawerOpen,
    getTopbarNavigationTitle: (state) => state.topbarNavigationTitle,
    getTopbarProcessTitle: (state) => state.topbarProcessTitle,
    getTopbarNavigationTimeLabel: (state) => state.topbarNavigationTimeLabel,
    getTopbarShowCloseButton: (state) => state.topbarShowCloseButton,
    getTopbarHideLeft: (state) => state.topbarHideLeft,
    getOverlayTopbar: (state) => state.overlayTopbar,
    getDateTimeConfig: (state) => state.dateTimeConfig || defaultDateTimeConfig,
  },
  actions: {
    toggleLeftDrawer() {
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },
    resetLoadingCount() {
      this.loadingCount = 0;
    },
    increaseLoadingCount() {
      this.loadingCount += 1;
    },
    decreaseLoadingCount() {
      if (this.loadingCount > 0) {
        this.loadingCount -= 1;
      }
    },
    setTopbarNavigationTitle(title) {
      this.topbarNavigationTitle = title;
    },
    setTopbarProcessTitle(title) {
      this.topbarProcessTitle = title;
    },
    setTopbarNavigationTimeLabel(label) {
      this.topbarNavigationTimeLabel = label;
    },
    setTopbarShowCloseButton(show) {
      this.topbarShowCloseButton = show;
    },
    setTopbarHideLeft(hide) {
      this.topbarHideLeft = !!hide;
    },
    setOverlayTopbar(value) {
      this.overlayTopbar = !!value;
    },
    setDateTimeConfig(config) {
      this.dateTimeConfig = { ...defaultDateTimeConfig, ...config };
    },
  },
});
